import { Point } from './Point/Point';
import { Point3_1 } from './Point/Point3_part1';
import { useTranslation,Trans } from 'react-i18next';

import classes from './PointCarousel.module.scss';

export const PointCarousel = () => {
  const { t } = useTranslation();

  const pointData = [
    {
      number: '01',
      title: <Trans i18nKey="about:point.01.title" components={{ 1: <br className="pconly" />, 2: <br className="sponly" /> }} />,
      description: <Trans i18nKey="about:point.01.description" components={{ 1: <br className="pconly" />, 2: <br className="sponly" />, 3: <span className="nowrap" /> }} />
    },
    {
      number: '02',
      title: t('about:point.02.title'),
      description: <Trans i18nKey="about:point.02.description" components={{ 1: <br className="pconly" />, 2: <br className="sponly" />, 3: <span className="nowrap" /> }} />
    },
    {
      number: '03',
      title: t('about:point.03.title'),
    }
  ];


return (
  <div className={classes.sliderWrap}>
    <div className={classes.pointList}>
      {pointData.map((point, index) => (
        index !== 2
          ? <Point key={index} {...point} />
          : <Point key={index} {...point}><Point3_1 /></Point>
      ))}
    </div>
  </div>
);

    };
